import type { IconProps } from './types';
import './icons.css';

export default function ExpandAll({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-expand-all ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M13.815 10.176a.667.667 0 0 1 .903.98l-2.47 2.275a1.163 1.163 0 0 1-1.563 0l-2.47-2.275a.667.667 0 0 1 .903-.98l2.349 2.162zM6 10.666A.667.667 0 0 1 6 12H2a.667.667 0 0 1 0-1.334zm0-3.333a.667.667 0 0 1 0 1.333H2a.667.667 0 1 1 0-1.333zm4.685-5.031a1.163 1.163 0 0 1 1.563 0l2.47 2.274a.666.666 0 1 1-.903.98l-2.348-2.161-2.349 2.162a.667.667 0 0 1-.903-.98zM6 4a.667.667 0 1 1 0 1.333H2A.667.667 0 0 1 2 4z"
      />
    </svg>
  );
}
